/**
 * main-product-kg.js
 *
 * Product V8 is a single-product PDP section. The product/template defines
 * the audience, flavor cards select real variants, and selling_plan_offer
 * blocks define subscription offers for that product.
 */

(function () {
  var scriptTag = document.currentScript;
  var sectionId = scriptTag ? scriptTag.dataset.id : null;

  function getSection() {
    return sectionId ? document.getElementById(sectionId) : document;
  }

  function fmtMoney(cents) {
    if (cents == null) return '';
    var val = cents / 100;
    return '$' + (val % 1 === 0 ? val.toFixed(0) : val.toFixed(2));
  }

  function parseProductJSON(section) {
    var el = section.querySelector('.productKGJSON');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function getActiveOffer(section) {
    var select = section.querySelector('.productKGOfferSelect');
    if (!select) return null;
    return select.selectedOptions[0] || select.options[0] || null;
  }

  function getPlanAllocation(variant, offer) {
    if (!variant || !offer || !variant.selling_plan_allocations) return null;
    var planId = String(offer.value || '');
    return variant.selling_plan_allocations.find(function (allocation) {
      return String(allocation.selling_plan_id) === planId;
    }) || null;
  }

  function setText(el, value) {
    if (el) el.textContent = value || '';
  }

  function setHtml(el, value) {
    if (el) el.innerHTML = value || '';
  }

  function initGallerySwiper(section) {
    if (typeof Swiper === 'undefined') return;
    section.querySelectorAll('.productVisualSwiperGroupItem').forEach(function (el) {
      var swiperEl = el.querySelector('.productVisualSwiper');
      if (!swiperEl) return;

      var instance = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: true,
        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
        on: {
          slideChange: function () {
            var thumbs = el.querySelectorAll('.productVisualThumbsSlide');
            thumbs.forEach(function (thumb) { thumb.classList.remove('active'); });
            if (thumbs[this.realIndex]) thumbs[this.realIndex].classList.add('active');
          }
        }
      });

      el.querySelectorAll('.productVisualThumbsSlide').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          instance.slideTo(parseInt(this.dataset.index, 10) - 1);
        });
      });
    });
  }

  function switchGallery(section, id) {
    section.querySelectorAll('.productVisualSwiperGroupItem').forEach(function (el) {
      el.classList.toggle('active', el.dataset.id === id);
    });
  }

  function resolveVariant(productData, flavorValue) {
    if (!productData || !productData.variants) return null;
    return productData.variants.find(function (variant) {
      return variant.options.indexOf(flavorValue) !== -1;
    }) || null;
  }

  function applyOfferAvailability(section, variant) {
    var select = section.querySelector('.productKGOfferSelect');
    if (!select) return;

    var allocations = variant && variant.selling_plan_allocations ? variant.selling_plan_allocations : [];
    var availablePlanIds = allocations.map(function (allocation) {
      return String(allocation.selling_plan_id);
    });
    if (!availablePlanIds.length) return;

    var needsReselect = false;
    Array.prototype.forEach.call(select.options, function (option) {
      var isAvailable = availablePlanIds.indexOf(String(option.value)) !== -1;
      option.disabled = !isAvailable;
      if (!isAvailable && option.selected) {
        option.selected = false;
        needsReselect = true;
      }
    });

    if (needsReselect) {
      var firstAvailable = Array.prototype.find.call(select.options, function (option) {
        return !option.disabled;
      });
      if (firstAvailable) firstAvailable.selected = true;
    }
  }

  function applyOfferTexts(section, variant) {
    var offer = getActiveOffer(section);
    var isSub = section.querySelector('.productKGPurchaseRadio[value="subscription"]:checked') !== null;
    var allocation = getPlanAllocation(variant, offer);

    var subPriceText = offer ? (offer.dataset.subscriptionPriceText || '') : '';
    var subCadence = offer ? (offer.dataset.subscriptionCadence || '') : '';
    var otpPriceText = offer ? (offer.dataset.otpPriceText || '') : '';
    var discountLabel = offer ? (offer.dataset.discountLabel || '') : '';
    var deliveryText = offer ? (offer.dataset.deliveryText || '') : '';
    var servingsDescription = offer ? (offer.dataset.servingsDescription || '') : '';
    var servingsPer = offer ? (offer.dataset.servingsPer || '') : '';
    var otpSupplyText = offer ? (offer.dataset.otpSupplyText || '') : '';

    if (!subPriceText) subPriceText = allocation ? fmtMoney(allocation.price) : fmtMoney(variant && variant.price);
    if (!otpPriceText) otpPriceText = fmtMoney(variant && variant.price);

    var mainPriceEl = section.querySelector('.productKGPrice');
    if (mainPriceEl) mainPriceEl.textContent = isSub ? subPriceText : otpPriceText;

    var pricePerEl = section.querySelector('.productKGPricePer');
    if (pricePerEl) {
      if (isSub && subCadence) {
        pricePerEl.textContent = '/' + subCadence;
        pricePerEl.style.display = '';
      } else {
        pricePerEl.style.display = 'none';
      }
    }

    var subPriceEl = section.querySelector('.productKGSubPrice');
    if (subPriceEl) {
      subPriceEl.textContent = subPriceText;
    }

    // v8: cadence and OTP compare live in dedicated spans next to .productKGSubPrice
    var subBoxPricePerEl = section.querySelector('.productKGSubBoxPricePer');
    if (subBoxPricePerEl) {
      if (subCadence) {
        subBoxPricePerEl.textContent = '/' + subCadence;
        subBoxPricePerEl.style.display = '';
      } else {
        subBoxPricePerEl.style.display = 'none';
      }
    }
    var subBoxCompareEl = section.querySelector('.productKGSubBoxComparePrice');
    var subCompareText = offer ? (offer.dataset.subCompareText || '') : '';
    if (!subCompareText) subCompareText = otpPriceText;
    if (subBoxCompareEl) {
      if (subCompareText) {
        subBoxCompareEl.textContent = subCompareText;
        subBoxCompareEl.style.display = '';
      } else {
        subBoxCompareEl.style.display = 'none';
      }
    }
    // v8: plan title + servings line in the offer card header
    var subBoxTitleEl = section.querySelector('.productKGSubBoxHeaderTitle');
    if (subBoxTitleEl && offer && offer.dataset.label) subBoxTitleEl.textContent = offer.dataset.label;
    setHtml(section.querySelector('.productKGSubBoxHeaderServings'), servingsDescription);

    // v8: dynamic "Save X%" pill in the top price row
    var saveBadgeEl = section.querySelector('.productKGPriceSaveBadge');
    if (saveBadgeEl) {
      if (discountLabel) {
        saveBadgeEl.textContent = 'Save ' + discountLabel;
        saveBadgeEl.style.display = '';
      } else {
        saveBadgeEl.style.display = 'none';
      }
    }
    // v8: dynamic promo badge inside the offer card — uses {discount} placeholder
    var promoBadgeEl = section.querySelector('.productKGSubBoxPromoBadge');
    if (promoBadgeEl) {
      var tpl = promoBadgeEl.dataset.template || promoBadgeEl.textContent || '';
      if (!promoBadgeEl.dataset.template) promoBadgeEl.dataset.template = tpl;
      if (discountLabel) {
        promoBadgeEl.textContent = promoBadgeEl.dataset.template.replace('{discount}', discountLabel);
        promoBadgeEl.style.display = '';
      } else {
        promoBadgeEl.style.display = 'none';
      }
    }

    setText(section.querySelector('.productKGSubBoxHeaderDiscount'), discountLabel || 'Save');
    setText(section.querySelector('.productKGSaveBadge'), discountLabel);
    setText(section.querySelector('.productKGOtpPrice'), otpPriceText);
    setText(section.querySelector('.productKGOtpSupply'), otpSupplyText);
    setHtml(section.querySelector('.productKGSubRowDelivery'), deliveryText);
    setHtml(section.querySelector('.productKGSubServings'), servingsDescription);

    var badgeEl = section.querySelector('.productKGPriceBadge');
    if (badgeEl && servingsPer) badgeEl.textContent = 'As low as ' + servingsPer + ' a day';

    var atcPriceEl = section.querySelector('.productKGSubAtcPrice');
    if (atcPriceEl) atcPriceEl.textContent = isSub ? subPriceText : otpPriceText;
  }

  function applyVariant(section, variant) {
    if (!variant) return;

    switchGallery(section, String(variant.id));

    var variantInput = section.querySelector('.productKGVariantInput');
    if (variantInput) variantInput.value = variant.id;

    applyOfferAvailability(section, variant);
    applyOfferTexts(section, variant);

    // v8: top compare-at price prefers the active offer's OTP text. Falls back
    // to variant.compare_at_price (or hides) when no offer text is configured.
    var comparePriceEl = section.querySelector('.productKGComparePrice');
    if (comparePriceEl) {
      var activeOffer = getActiveOffer(section);
      var compareText = (activeOffer && activeOffer.dataset.otpPriceText) || '';
      if (!compareText && variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareText = fmtMoney(variant.compare_at_price);
      }
      if (compareText) {
        comparePriceEl.textContent = compareText;
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    var atcBtn = section.querySelector('.productKGAtc');
    if (atcBtn) {
      var available = variant.available !== false;
      atcBtn.disabled = !available;
      setText(atcBtn.querySelector('.productKGAtcText'), available ? 'Add to Cart' : 'Sold Out');
    }

    var variantJsonEl = section.querySelector('.productKGVariantJSON');
    if (variantJsonEl) variantJsonEl.textContent = JSON.stringify(variant);

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  function updateFromSelections(section) {
    var productData = parseProductJSON(section);
    if (!productData) return;

    var flavorCard = section.querySelector('.productKGFlavorCard.is-selected');
    var variant = null;

    if (flavorCard) {
      var directVariantId = parseInt(flavorCard.dataset.variantId, 10);
      if (directVariantId) {
        variant = productData.variants.find(function (item) { return item.id === directVariantId; });
      }
      if (!variant) variant = resolveVariant(productData, flavorCard.dataset.flavorValue || '');
    }

    if (!variant) {
      var variantInput = section.querySelector('.productKGVariantInput');
      var currentId = variantInput ? parseInt(variantInput.value, 10) : null;
      if (currentId) {
        variant = productData.variants.find(function (item) { return item.id === currentId; });
      }
      if (!variant) variant = productData.variants.find(function (item) { return item.available; }) || productData.variants[0];
    }

    applyVariant(section, variant);
    updateAddonDisplay(section);
  }

  function initFlavorSelector(section) {
    var cards = section.querySelectorAll('.productKGFlavorCard');
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        cards.forEach(function (item) { item.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        updateFromSelections(section);
      });
    });
  }

  function initOfferSelector(section) {
    var select = section.querySelector('.productKGOfferSelect');
    if (!select) return;
    select.addEventListener('change', function () {
      updateFromSelections(section);
    });
  }

  function initPurchaseToggle(section) {
    section.querySelectorAll('.productKGPurchaseRadio').forEach(function (radio) {
      radio.addEventListener('change', function () {
        section.querySelectorAll('.productKGPurchaseRow').forEach(function (row) {
          row.classList.remove('is-selected');
        });
        var row = radio.closest('.productKGPurchaseRow');
        if (row) row.classList.add('is-selected');
        updateFromSelections(section);
      });
    });
  }

  function initFaqAccordion(section) {
    section.querySelectorAll('.productKGFaqBtn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isActive = btn.classList.contains('is-active');
        section.querySelectorAll('.productKGFaqBtn').forEach(function (item) { item.classList.remove('is-active'); });
        if (!isActive) btn.classList.add('is-active');
      });
    });
  }

  function initLabelDialog(section) {
    var openBtn = section.querySelector('.productKGLabelBtn');
    var dialog = section.querySelector('.productKGLabelDialog');
    if (!openBtn || !dialog) return;

    var labelSwiper = null;
    if (typeof Swiper !== 'undefined') {
      var swiperEl = dialog.querySelector('.productKGLabelSwiper');
      if (swiperEl) {
        labelSwiper = new Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 20,
          autoHeight: true,
          navigation: {
            prevEl: dialog.querySelector('.productKGLabelNavBtn.swiper-button-prev'),
            nextEl: dialog.querySelector('.productKGLabelNavBtn.swiper-button-next'),
          },
        });
      }
    }

    openBtn.addEventListener('click', function () {
      if (labelSwiper) {
        var variantInput = section.querySelector('.productKGVariantInput');
        var currentId = variantInput ? variantInput.value : null;
        if (currentId) {
          var slides = Array.from(dialog.querySelectorAll('.swiper-slide[data-id]'));
          var idx = slides.findIndex(function (slide) { return slide.dataset.id === String(currentId); });
          if (idx >= 0) labelSwiper.slideTo(idx, 0);
        }
      }
      document.body.classList.add('noScroll');
      dialog.showModal();
    });

    var closeBtn = dialog.querySelector('.productKGLabelDialogClose');
    if (closeBtn) closeBtn.addEventListener('click', function () {
      dialog.close();
      document.body.classList.remove('noScroll');
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        dialog.close();
        document.body.classList.remove('noScroll');
      }
    });

    dialog.addEventListener('close', function () {
      document.body.classList.remove('noScroll');
    });
  }

  function initAtcButton(section) {
    var atcBtn = section.querySelector('.productKGAtcSub');
    if (!atcBtn) return;

    atcBtn.addEventListener('click', async function () {
      this.classList.add('loading');

      var hasSub = section.querySelector('.productKGPurchaseRadio[value="subscription"]:checked') !== null;
      var activeOffer = getActiveOffer(section);
      var planId = activeOffer ? (parseInt(activeOffer.value, 10) || null) : null;
      var quantity = activeOffer ? (parseInt(activeOffer.dataset.quantity, 10) || 1) : 1;
      var variantInput = section.querySelector('.productKGVariantInput');
      var variantId = variantInput ? parseInt(variantInput.value, 10) : null;

      // Keep whatever is already in the cart so different products (e.g. Adults + Kids) can
      // coexist. Each subscription brings its own welcome-kit gifts, tagged with _gift_for
      // so they belong to this product and can be removed with it. Skip re-adding gifts this
      // product already contributed (e.g. when clicking Add to cart again).
      var currentCart = await getCart();
      var ownerHasGifts = (currentCart.items || []).some(function (item) {
        return item.properties && item.properties._gift && String(item.properties._gift_for) === String(variantId);
      });

      var formData = [];

      if (typeof giftsKG !== 'undefined' && !ownerHasGifts) {
        giftsKG.forEach(function (gift) {
          var giftId = parseInt(gift.id, 10);
          if (!giftId) return;
          if (hasSub || !gift.sub) {
            formData.push({ quantity: 1, id: giftId, properties: { _gift: true, _gift_for: String(variantId) } });
          }
        });
      }

      formData.push({
        quantity: quantity,
        id: variantId,
        selling_plan: hasSub ? planId : null,
        properties: hasSub && planId ? { _selling_plan_offer: planId } : {}
      });

      // Add-on (e.g. Kids Pack) rides along in the same cart call, mirroring
      // the purchase toggle: subscribes when the buyer subscribes (if the
      // add-on has a plan configured), otherwise one-time.
      var addon = getSelectedAddon(section, hasSub);
      if (addon) {
        formData.push({ quantity: 1, id: addon.id, selling_plan: addon.planId });
      }

      await addProduct({ items: formData });

      if (section.dataset && section.dataset.atcCheckout === 'true') {
        window.location.href = '/checkout';
        return;
      }

      this.classList.remove('loading');
      await openCart();
    });
  }

  function getSelectedAddon(section, hasSub) {
    var checkbox = section.querySelector('.productKGAddonCheckbox');
    if (!checkbox || !checkbox.checked) return null;
    var card = checkbox.closest('.productKGAddonCard');
    var pill = card ? card.querySelector('.productKGAddonFlavorPill.is-selected') : null;
    var source = pill || checkbox;
    var id = parseInt(source.dataset.variantId, 10);
    if (!id) return null;

    // Subscribe the add-on only when the buyer is subscribing AND this
    // variant actually carries the configured plan (data-sub-price present).
    var planId = null;
    if (hasSub && card && card.dataset.sellingPlanId && source.dataset.subPrice) {
      planId = parseInt(card.dataset.sellingPlanId, 10) || null;
    }
    return { id: id, planId: planId };
  }

  function updateAddonDisplay(section) {
    var card = section.querySelector('.productKGAddonCard');
    if (!card) return;

    var hasSub = section.querySelector('.productKGPurchaseRadio[value="subscription"]:checked') !== null;
    var pill = card.querySelector('.productKGAddonFlavorPill.is-selected');
    var source = pill || card.querySelector('.productKGAddonCheckbox');
    if (!source) return;

    var isSubMode = hasSub && !!card.dataset.sellingPlanId && !!source.dataset.subPrice;
    var base = parseInt(isSubMode ? source.dataset.subPrice : source.dataset.price, 10);
    if (!base) return;

    var pct = parseInt(card.dataset.discountPct, 10) || 0;
    var priceEl = card.querySelector('.productKGAddonPrice');
    var compareEl = card.querySelector('.productKGAddonComparePrice');
    if (priceEl) priceEl.textContent = fmtMoney(pct > 0 ? Math.round(base * (100 - pct) / 100) : base);
    if (compareEl) compareEl.textContent = fmtMoney(base);

    var cadenceEl = card.querySelector('.productKGAddonCadence');
    if (cadenceEl) cadenceEl.style.display = isSubMode ? '' : 'none';
    var subNoteEl = card.querySelector('.productKGAddonSubNote');
    if (subNoteEl) subNoteEl.style.display = isSubMode ? '' : 'none';
  }

  function initAddonCard(section) {
    var card = section.querySelector('.productKGAddonCard');
    if (!card) return;

    card.querySelectorAll('.productKGAddonFlavorPill').forEach(function (pill) {
      pill.addEventListener('click', function (event) {
        // Buttons live inside the card's <label>; stop the click from also
        // toggling the add-on checkbox.
        event.preventDefault();
        card.querySelectorAll('.productKGAddonFlavorPill').forEach(function (item) {
          item.classList.remove('is-selected');
        });
        pill.classList.add('is-selected');
        updateAddonDisplay(section);
      });
    });

    updateAddonDisplay(section);
  }

  function initGiftDialogs(section) {
    section.querySelectorAll('.productKGSubPointLearnBtn').forEach(function (btn) {
      var item = btn.closest('.productKGSubPointItem');
      var dialog = item ? item.querySelector('.productKGSubPointLearnDialog') : null;
      if (!dialog) return;

      btn.addEventListener('click', function () { dialog.showModal(); });
      dialog.querySelectorAll('.productKGSubPointLearnClose').forEach(function (closeBtn) {
        closeBtn.addEventListener('click', function () { dialog.close(); });
      });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail && event.detail.sectionId === sectionId) init();
  });

  function init() {
    var section = getSection();
    if (!section) return;

    initGallerySwiper(section);
    initFlavorSelector(section);
    initOfferSelector(section);
    initPurchaseToggle(section);
    initAtcButton(section);
    initAddonCard(section);
    initFaqAccordion(section);
    initLabelDialog(section);
    initGiftDialogs(section);
    updateFromSelections(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
